<script setup lang="ts">
import { ref } from "vue";

import { PlusIcon } from "~/icons";
import { makeUuid } from "~/utils/common";

const emit = defineEmits<{
  input: [event: Event];
}>();

const inputId = ref(`input-${makeUuid()}`);
</script>

<template>
  <label
    :for="inputId"
    class="flex size-20 cursor-pointer items-center justify-center rounded-sm border border-dashed border-hvy p-1 text-sm text-vlt focus-ring-std hover:bg-lt print:hidden">
    <span class="sr-only">Add attachment</span>
    <input :id="inputId" type="file" class="sr-only" accept="*" multiple @input="emit('input', $event)" />
    <PlusIcon class="icon-md" />
  </label>
</template>
